import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'jrui-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatToolbarModule, RouterModule],
})
export class VerifyEmailComponent implements OnInit {
  @Input() email = '';
  @Output() loginClick = new EventEmitter();
  @Output() reEnter = new EventEmitter();
  @Output() reSend = new EventEmitter();

  showAutomationButton = false;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngOnInit() {
    this.checkEnv();
  }

  private checkEnv() {
    if (isPlatformBrowser(this.platformId)) { 
      const href = window.location.href.split('/');
      if (href.includes('localhost:4200') || href.includes('dev.jobring.ai')) {
        this.showAutomationButton = true;
      }
    }
  }

  onReEnter() {
    this.reEnter.emit();
  }

  onReSend() {
    this.reSend.emit();
  }

  login() {
    this.loginClick.emit();
  }
}
